import MicroModal from 'micromodal';
import {
	__,
	sprintf
} from '@wordpress/i18n';

document.addEventListener("DOMContentLoaded", function() {
	const simpleModalEl = document.querySelector( '.simple-modal-block' );

	if ( ! simpleModalEl ) {
		return;
	}

	if ( simpleModalEl.id ) {
		const delayInSeconds = simpleModalEl.dataset?.smbDelay;
		const intervalInDays = simpleModalEl.dataset?.interval || 3;
		const storageKey = `${simpleModalEl.id}-interval`;
		const intervalDate = localStorage.getItem( storageKey );

		if ( ! delayInSeconds ) {
			MicroModal.init( {
				openClass: 'is-open',
				openTrigger: 'data-smb-open',
				closeTrigger: 'data-smb-close',
				disableScroll: true,
			} );

			return;
		}

		if (
			intervalDate &&
			((new Date(parseInt(intervalDate))).getTime() - (new Date()).getTime()) > 0
		) {
			return;
		}

		setTimeout( () => {
			try {
				MicroModal.show( simpleModalEl.id, {
					openClass: 'is-open',
					openTrigger: 'data-smb-open',
					closeTrigger: 'data-smb-close',
					disableScroll: true,
					onShow: () => {
						const nextIntervalDate = new Date((new Date()).setDate( (new Date()).getDate() + intervalInDays ));

						localStorage.setItem( storageKey, String( nextIntervalDate.getTime() ) );
					},
				});
			} catch ( error ) {
				console.error(
					sprintf(
						// translators: %s: The error message.
						__( 'Simple modal block error: %s', 'simple-modal-block' ),
						error
					)
				);
			}
		}, delayInSeconds * 1000 );
	} else {
		console.warn(
			__( 'The simple modal block requires a anchor value to be set.', 'simple-modal-block' )
		);
	}
});
